import { z } from 'zod';

export const externalFeedbackSearchSchema = z.object({
  serviceId: z.coerce.string().trim().min(1),
  serviceType: z.coerce.string().trim().min(1),
  orderKey: z.coerce.string().trim().min(1),
  date: z.coerce.string().regex(/^\d{2}\.\d{2}\.\d{4}$/),
});
